class CatalogLoadMore {
    constructor($el) {
        this.$el = $el;
        this.page = 1;

        if(this.$el.length) {
            this.$resultsCountLabel = $('.number-results__label');
            this.$dimensionsForm = $('.shop-filters-form');
            // $('input[name="results_offset"]').val(1);

            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onLoadMoreFn = this._onLoadMore.bind(this);
        this.onSearchDoneFn = this._onSearchDone.bind(this);
        this.onSearchFailFn = this._onSearchFail.bind(this);
        this.lockSearchFn = this._lockSearch.bind(this);
        this.unlockSearchFn = this._unlockSearch.bind(this);
        this.onDimensionsSearchFn = this._onDimensionsSearch.bind(this);

        this.$el.on('click', this.onLoadMoreFn);
        this.$dimensionsForm.on('submit', this.onDimensionsSearchFn);
    }

    _onLoadMore(e) {
        e.preventDefault();
        const target = e.target;
        // const nextPage = target.getAttribute('href') || '';
        // const matches = nextPage.match(/\/catalogue\/(categorie)\/([0-9]+)\/([0-9]+)\/?/);

        if(!target.classList.contains('loading')) {
            const formData = this._getFormData();
            console.log('formData:', formData);
            const request = $.ajax({
                url: pro.ajax_url,
                type: 'post',
                data: formData,
                // dataType: 'html',
                // contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                beforeSend: this.lockSearchFn
            });
            
            request.done(this.onSearchDoneFn);
            request.fail(this.onSearchFailFn);
            request.always(this.unlockSearchFn);
        }
    }

    _onDimensionsSearch(e) {
        e.preventDefault();

        if(!this.$dimensionsForm.hasClass('loading')) {
            $('input[name="results_offset"]').val(0);
            const formData = this._getFormData();
            console.log('formData:', formData);
            const $searchColRight = $('.results-list__col-right');
            $searchColRight.find('.results-list__item').remove();
            $searchColRight.find('.results-list__next-results-wrapper').empty();

            const request = $.ajax({
                url: pro.ajax_url,
                type: 'post',
                data: formData,
                // dataType: 'html',
                // contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                beforeSend: this.lockSearchFn
            });
            
            request.done(this.onSearchDoneFn);
            request.fail(this.onSearchFailFn);
            request.always(this.unlockSearchFn);
        }
    }

    _getFormData() {
        let data = {};
        const formDataArray = $('.shop-filters-form').serializeArray();
        console.log(formDataArray);
        formDataArray.map((formDataPart) => {
            if(formDataPart.value !== '') {
                data[formDataPart.name] = formDataPart.value;
            }
        });

        return {
            action: 'do_prodex_search',
            ...data,
            _wpnonce_catalog: pro._wpnonce_catalog
        };
    }

    _onSearchFail(jqXHR, textStatus, errorThrown) {
        console.log('onSearchFail', jqXHR, textStatus, errorThrown);  
    }

    _lockSearch() {
        this.$el.addClass('loading');
    }

    _unlockSearch() {
        this.$el.removeClass('loading');
    }

    _onSearchDone(response, textStatus, jqXHR) {
        console.log(response);
        // $('.results-list__col-left').empty();
        // $('.results-list__col-left').html(response.data.filters);

        if(response.data.results_categories && response.data.results_categories.length) {
            var $categoriesLinks = $('.categories-links');
            
            if($categoriesLinks.length) {
                var $categoriesLinksList = $categoriesLinks.find('ul');
                
                if($categoriesLinksList.length) {
                    $categoriesLinksList.empty();
                    let tpl = '';
                    response.data.results_categories.forEach((result_category) => {
                        if(pro?.pages?.catalog_category_page) {
                            tpl += `<li><a href="${pro.pages.catalog_category_page}${result_category.id}/">${result_category[`name_${response.data.language_code}`]}</a></li>`;
                        }
                    });
                    
                    $categoriesLinksList.append(tpl);
                }
            }
        }

        $('.results-list__col-right .results-list__next-results-wrapper').append(response.data.results);
        $('input[name="results_offset"]').val(response.data.page + 1);
        this.$el.attr('href', window.location.href + (response.data.page + 1));
        this.$resultsCountLabel.text(response.data.results_count);
console.log('control: ', (response.data.page + 1) * 24, response.data.results_count);
        if((response.data.page + 1) * 24 >= response.data.results_count) {
            this.$el.hide();
        }
        else {
            this.$el.show();
        }
        // // console.log('onSearchDone', response);
        // // Unbind previous results blocks
        // this.unbindResults();
        // // Empty results container
        // this.$resultsContainer.empty();

        // // Unbind previous fitlers
        // this.unbindFilters();
        // // Empty form filters
        // this.$form.empty();

        // // Unbind previous pagination items
        // this.unbindPagination();
        // // Empty the pagination wrapper
        // this.$paginationWrapper.empty();

        // if(response.data.results) {
        //     // Add new results blocks
        //     this.$resultsContainer.html(response.data.results);
        //     // Bind new results blocks
        //     this.bindResults();
            
        //     // Add new filters
        //     this.$form.prepend(response.data.filters);
        //     // Bind new filters
        //     this.bindFilters();

        //     // Add the new pagination
        //     this.$paginationWrapper.prepend(response.data.pagination);
        //     // Bind new pagination items
        //     this.bindPagination();
        // }
    }
}

export default CatalogLoadMore;
